import { DiscardableModel } from './DiscardableModel';
import { ErroredModel } from './ErroredModel';
import { Field } from './FieldCommon';
import { PaginationMeta } from './pagination';
import { Step } from './Step';
import { TaskTemplate } from './TaskTemplate';
import { TaggableModel } from './Tag';

export type Task = ErroredModel &
  DiscardableModel &
  TaggableModel & {
    uuid: string;
    name: string;
    account_uuid?: string;
    account_name?: string;
    account_display_name?: string;
    parent_type?: string;
    parent_location?: string;
    description?: string;
    due_date?: string;
    task_template_uuid: string;
    task_template_name?: string;
    fields: Field[];
    steps: Step[];
    employee_uuid?: string;
    employee_display_name?: string;
    employee_email?: string;
    type_uuid?: string;
    type_value?: string;
    event_uuid?: string;
    event_display_name?: string;
    task_template?: TaskTemplate;
    completed?: boolean;
    status: TaskStatus;
    start_date_offset: number | null;
    due_date_offset: number | null;
    account_code?: string;
    start_date: string | null;
    depends_on_uuid: string | null;
    new_record?: boolean;
  };

export type TaskResponse = {
  data: Task[];
  meta: PaginationMeta;
};

export interface TaskItemQueryParams {
  account?: string;
  template?: string;
}

// This enum represents the actual status values stored in the database for each task.
// These are used in model validations, business logic, and persisted in the backend.
export enum TaskStatus {
  NOT_STARTED = 'not_started',
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  ON_HOLD = 'on_hold',
  COMPLETED = 'completed',
}

// This enum represents filter options used in the frontend (e.g. dashboard filters, tables).
// These include both raw status values and virtual filters like "active" and "overdue".
// Used to map filters to scopes (e.g., `.active`, `.overdue`) or status-based filters.
export enum TaskStatusFilter {
  NOT_STARTED = 'not_started',
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  ON_HOLD = 'on_hold',
  ACTIVE = 'active',
  OVERDUE = 'overdue',
  COMPLETED = 'completed',
}
